import KeyConfirm from '../../atoms/container/keyConfirm';
import VirtualKeyboardContext from '../../../../shared/components/utils/context/virtualKeyboardContext';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useContext, useState } from 'react';
import TranslationManager from '@shared/assets/locale/translationsManager';

function ConfirmKey({
  index,
  alternateKeyboard,
}: {
  index: number[];
  alternateKeyboard?: boolean;
}) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { listIndex, listFocused, onClick } = useContext(
    VirtualKeyboardContext
  );
  const [hovered, setHovered] = useState(false);
  const focused = !enabled && listFocused && index.includes(listIndex);
  return (
    <KeyConfirm
      onClick={() => index.length && onClick(index[0])}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(focused)}
      focused={hovered || focused}
      alternateKeyboard={alternateKeyboard}
    >
      {TranslationManager.get('COMPONENTS.SEARCH.SEARCH')}
    </KeyConfirm>
  );
}

export default ConfirmKey;
